import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-23",
  "use": "icon-icon-nav-23-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-23\"><path d=\"M512 232.704V128L372.352 267.648 512 407.296V302.528A209.6 209.6 0 0 1 721.472 512c0 35.2-8.768 68.8-24.448 97.728l50.944 51.008c27.264-42.944 43.328-93.952 43.328-148.736A279.168 279.168 0 0 0 512 232.704z m0 488.768A209.6 209.6 0 0 1 302.528 512c0-35.2 8.768-68.8 24.448-97.728l-50.944-51.008A276.864 276.864 0 0 0 232.704 512 279.168 279.168 0 0 0 512 791.296V896l139.648-139.648L512 616.704v104.768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-23.svg
// module id = 9zUe
// module chunks = 3